import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../../services-http/auth/auth.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import Swal from 'sweetalert2';



@Component({
  selector: 'app-create-account',
  templateUrl: './create-account.component.html',
  styleUrls: ['./create-account.component.scss']
})
export class CreateAccountComponent implements OnInit {

  profileForm!: FormGroup;
  optionsSelect: any = [];
  searchResult: any = [];
  selectedCoop: any;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.loginType();

    this.profileForm = this.fb.group({
      usertype: ['', Validators.required],
      agenttype: [''],
      coop_maincode: ['', Validators.required],
      coop_branch: ['', Validators.required],
      firstname: ['', [Validators.required, Validators.minLength(2)]],
      middlename: [''],
      lastname: ['', [Validators.required, Validators.minLength(2)]],
      address: ['', Validators.required],
      contact_no: ['', [Validators.required, Validators.pattern('^[0-9]{10,11}$')]],
      username: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      password_confirmation: ['', Validators.required],
      privacy: [false, Validators.requiredTrue],
      designation: ['', Validators.required]
    })


    this.profileForm.get('usertype')!.valueChanges.subscribe((usertype:any) => {
      // let agenttypeControl = this.profileForm.get('agenttype');
    
      if (usertype==5) {
        this.profileForm.get("agenttype").setValidators([Validators.required]);
      } else {
        this.profileForm.get("agenttype").clearValidators();
      }
      this.profileForm.get("agenttype").updateValueAndValidity();


      if(usertype>6){
        this.profileForm.patchValue({coop_maincode: '3020-CLIMBS LIFE AND GENERAL INSURANCE COOPERATIVE'});

        this.selectedCoop="3020-CLIMBS LIFE AND GENERAL INSURANCE COOPERATIVE"
        this.searchResult = [{ CoopNum: 3020, Name: "3020-CLIMBS LIFE AND GENERAL INSURANCE COOPERATIVE", Area: "M" }]
      }
    });


    this.profileForm.get('coop_maincode')!.valueChanges.pipe(
      debounceTime(2000),
      distinctUntilChanged()
    ).subscribe(value => {

      if( value.includes('-')==false && value ){
        this.search(value);
      }

    });
  }


  backtoLogin() {
    this.router.navigateByUrl('/welcome/home');
  }


  onSubmit() {

    let coop = this.searchResult.find(x=> x.CoopNum==this.selectedCoop.split('-')[0]);

    let data = {
      coop_maincode        :coop.CoopNum,
      usertype             :this.profileForm.get('usertype').value,
      username             :this.profileForm.get('username').value,
      password             :this.profileForm.get('password').value,
      password_confirmation:this.profileForm.get('password_confirmation').value,
      contact_no           :this.profileForm.get('contact_no').value,
      address              :this.profileForm.get('address').value,
      firstname            :this.profileForm.get('firstname').value,
      middlename           :this.profileForm.get('middlename').value,
      lastname             :this.profileForm.get('lastname').value,
      agentType            :this.profileForm.get('agenttype').value,
      coop_branch          :this.profileForm.get('coop_branch').value,
      Area                 :coop.Area,
      gam_code             :coop.agent_code,
      designation          :this.profileForm.get('designation').value,
    }
      this.authService.signUp(data, false).subscribe( res => {
      
        Swal.fire(
          'Success',
          res['msg'],
          'success'
        );

        this.backtoLogin(); 
        
      },error=>{
        let err=error.error;
        let msg='';

        Object.keys(err).forEach(function(key){
          msg+=err[key]+'<br/>';
        })

        Swal.fire(
          'Oppss!',
          msg,
          'error'
        );
      });
  }

  coopselected(e){
    this.selectedCoop = e;
  }




  search(e){

    this.authService.searchCoop(
    { 
      searchkey: e,
      agentType:this.profileForm.get('agenttype').value 
    }, this.profileForm.get('usertype').value)
    
    .subscribe((res:any) => {
      this.searchResult=res; 

    },error=>{
      let err=error.error;
      let msg='';
    
      Object.keys(err).forEach(function(key){
        msg+=err[key]+'<br/>';
      })
    
      Swal.fire(
        'Oppss!',
        msg,
        'error'
      ); 
    });
  }


  loginType(){
    this.authService.loginType()
      .subscribe(res=>{
        this.optionsSelect=res;
    });
  }


}
